import { render } from "./HighlightNumber.vue?vue&type=template&id=6c09ae93"
import script from "./HighlightNumber.vue?vue&type=script&lang=js"
export * from "./HighlightNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__